import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ErrorModule } from '../error';
import { IconModule } from '../icon';
import { SubscriptionDetailsNoRowsOverlayComponent } from './';

@NgModule({
  declarations: [SubscriptionDetailsNoRowsOverlayComponent],
  imports: [CommonModule, IconModule, ErrorModule],
  exports: [SubscriptionDetailsNoRowsOverlayComponent],
})
export class SubscriptionDetailsNoRowsOverlayModule {}
